
import ogPagesMixins from '@/mixins/ogPagesMixins'
// Настройки SEO полей head
const SEO = {
  TITLE: 'Сообщества | Мегасреда',
  DESCRIPTION:
    'Чтобы вам было удобнее получать полезный контент, мы объединили его по тематикам',
  OG_IMAGE: {
    url: 'https://megasreda.ru/img/community_ogg.jpg',
    urlVk: 'https://megasreda.ru/img/community_ogg-vk.jpg',
    urlTw: 'https://megasreda.ru/img/community_ogg.jpg',
    type: 'image/jpeg',
    width: 1200,
    height: 630,
  },
}
export default {
  mixins: [ogPagesMixins],
  scrollToTop: true,

  async asyncData({ $axios }) {
    const collections = await $axios.$get('/collection', {
      params: {
        statistics: true,
      },
    })
    return {
      collections,
    }
  },
  computed: {
    seoTitle() {
      return SEO.TITLE
    },
    seoDescription() {
      return SEO.DESCRIPTION
    },
    seoImage() {
      return SEO.OG_IMAGE
    },
  },
}
